import React from "react";
import { motion } from "framer-motion";
import { Search, Handshake, Truck, FileCheck } from "lucide-react";
import { STEPS } from "../mock";

const ICONS = [Search, Handshake, Truck, FileCheck];

const Process = () => {
  return (
    <section className="section-pad relative bg-[#0b0b0e] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="eyebrow">Le process</span>
          <h2 className="section-title text-4xl md:text-6xl text-white mt-5">
            4 étapes vers <span className="racing-text">votre bolide</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {STEPS.map((step, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={step.num}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ delay: i * 0.15, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                className="relative group"
              >
                <div className="card-lift glass rounded-2xl p-7 h-full">
                  <div className="flex items-center justify-between mb-6">
                    <span className="font-display font-extrabold text-5xl text-white/8 group-hover:text-[#ff6a00]/20 transition-colors">
                      {step.num}
                    </span>
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#e11d2a] to-[#ff6a00] flex items-center justify-center red-glow">
                      <Icon size={22} className="text-white" />
                    </div>
                  </div>
                  <h3 className="font-display font-bold text-xl text-white mb-2">
                    {step.title}
                  </h3>
                  <p className="text-white/55 text-sm leading-relaxed">{step.text}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
